import Styles from './styles.module.css';
import Styless from './../styles.module.css';
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { PiCheckCircleFill } from 'react-icons/pi';
import { VscChevronRight } from 'react-icons/vsc';
import Summary from "./2.edit/1.summary";
import Point from "./2.edit/3.point";
import Number from "./2.edit/4.number";
import Photos from "./2.edit/5.strong";
import Interview from "./2.edit/6.interview";
import Person from "./2.edit/7.person";
import Navigation from "./navigation/index";
import Document from "./2.edit/8.document";
import { doc, getFirestore, onSnapshot } from 'firebase/firestore';
import Slider from "src/pages/recruit/recruit/4.strongImage/index";
import BackCaution from "./2.edit/backCaution/index";
import Public from "./unPublic/index";
import RecruitPageHeader from 'src/pages/recruit/recruit/0.header';
import { defaultDocumentData, defaultInterviewsData, defaultNumberData, defaultPamphlet, defaultPersonData, defaultPointData, defaultStrongData, defaultSummaryData, formatDocument, formatInterviews, formatNumber, formatPamphlet, formatPerson, formatPoint, formatStrong, formatSummary } from '../../../type';
import RecruitPageTitle from 'src/pages/recruit/recruit/title';
import RecruitPagePoint from 'src/pages/recruit/recruit/1.point/index';
import RecruitPageNumber from 'src/pages/recruit/recruit/3.number';
import Stores from "./2.edit/2.store";
import RecruitPageStores from 'src/pages/recruit/recruit/2.stores/index';
import RecruitPagesInterviews from 'src/pages/recruit/recruit/5.interviews';
import RecruitPagesPerson from 'src/pages/recruit/recruit/6.person';
import { useAppSelector } from 'src/salon/app/hook';
import { useLocation } from 'react-router-dom';

const MOBILE_NAV_ITEMS = [
  { label: "店舗概要", index: 1 },
  { label: "募集店舗", index: 2 },
  { label: "会社の魅力3選", index: 3 },
  { label: "数字で見る", index: 4 },
  { label: "写真で見る", index: 5 },
  { label: "インタビュー", index: 6 },
  { label: "求める人物像", index: 7 },
  { label: "応募設定", index: 8 },
];

const Recruit: React.FC = () => {

  const db = getFirestore();

  const company  = useAppSelector((state) => state.company.company);
  const location = useLocation();

  const [ navigation, setNavigation ] = useState<number>(location.state?.recruitSection ?? 1);
  
  const [ documentId, setDocumentId ] = useState<string>("");
  
  const [ summary, setSummary ] = useState(defaultSummaryData);
  const memoizedSummary = useMemo(() => summary, [summary]);

  // 企業情報の編集で選択直後（アップロード前）の画像を即時プレビューする
  const [ summaryLocalImages, setSummaryLocalImages ] = useState<Record<string, string>>({});
  const registerSummaryPreviewImage = useCallback((id: string, url: string) => {
    setSummaryLocalImages(prev => ({ ...prev, [id]: url }));
  }, []);
  
  type storeData = {
    isCompleted: boolean,
  };

  const [ store, setStore ] = useState<storeData>({
    isCompleted: false,
  });

  const [ point, setPoint ] = useState(defaultPointData);
  const memoizedPoint = useMemo(() => point, [point]);

  const [ number, setNumber ] = useState(defaultNumberData);
  const memoizedNumber = useMemo(() => number, [number]);

  const [ strong, setStrong ] = useState(defaultStrongData);
  const memoizedStrong = useMemo(() => strong, [strong]);

  const [ interviews, setInterviews ] = useState(defaultInterviewsData);
  const memoizedInterviews = useMemo(() => interviews, [interviews]);
  
  const [interviewImage1File, setInterviewImage1File] = useState<File | null>(null);
  const [interviewImage2File, setInterviewImage2File] = useState<File | null>(null);
  const [interviewImage3File, setInterviewImage3File] = useState<File | null>(null);
  const [interviewImage4File, setInterviewImage4File] = useState<File | null>(null);
  const [interviewImage5File, setInterviewImage5File] = useState<File | null>(null);
  const [interviewImage6File, setInterviewImage6File] = useState<File | null>(null);

  const [ person, setPerson ] = useState(defaultPersonData);
  const memoizedPerson = useMemo(() => person, [person]);

  const [ document, setDocument ] = useState(defaultDocumentData);
  const memoizedDocument = useMemo(() => document, [document]);

  const [ status, setStatus ] = useState<number>(0);
  const [ progress, setProgress ] = useState<boolean[]>( Array(11).fill(false) );

  const [ changeData, setChangeData ] = useState<boolean>(false);
  const [ backCaution, setBackCaution ] = useState<number>(0);
  const [ mobileNavOpen, setMobileNavOpen ] = useState(false);

  const navRef = useRef<HTMLDivElement>(null);

  const [ storeImageLocal, setStoreImageLocal ] = useState<string>("");

  const [ pamphlet, setPamphlet ] = useState(defaultPamphlet);
  const memoizedPamphlet = useMemo(() => pamphlet, [pamphlet]);

  useEffect(() => {
    if (!company?.id) return;
    const modified = company.id + '_2027';

    setDocumentId(modified);

    const unsubscribe = 
    onSnapshot(doc(db, "recruits", modified), (docSnap) => {
      if (docSnap.exists()) {

        const docData = docSnap.data();
        setStatus(docData.recruitStatus);

        const statusKeys = [
          docData.summary?.isCompleted && docData.summary.images.length > 0,
          docData.store?.isCompleted,
          docData.point?.isCompleted,
          docData.number?.isCompleted,
          docData.strong?.isCompleted,
          docData.interviews?.isCompleted,
          docData.person?.isCompleted,
          docData.document?.isCompleted,
        ];

        setProgress(statusKeys);

        const storeFormatted = {
          isCompleted: docData.store?.isCompleted ?? false,
        };
        setStore(storeFormatted);

        setSummary(formatSummary(docData));
        setPoint(formatPoint(docData));
        setNumber(formatNumber(docData));
        setStrong(formatStrong(docData));
        setInterviews(formatInterviews(docData));
        setPerson(formatPerson(docData));
        setDocument(formatDocument(docData));
        setPamphlet(formatPamphlet(docData));
      } else {}
    });
    return () => unsubscribe();
  }, [ company.id, navigation ]);

  const isWindows = navigator.userAgent.includes("Windows");
  const zoom = isWindows ? 1.25 : 1.0;

  function handleMobilePublish() {
    const buttons = navRef.current?.querySelectorAll('button');
    if (buttons && buttons.length > 0) {
      (buttons[buttons.length - 1] as HTMLButtonElement).click();
    }
  }

  const currentNavLabel = MOBILE_NAV_ITEMS.find(item => item.index === navigation)?.label ?? "";

  return (
    <>
    {status === 3 ?
      <div className={Styless.works_service}>
        <div>
          <div className={Styles.box}>

            {/* デスクトップ用ナビゲーション（モバイルでは画面外に配置して機能を保持） */}
            <div ref={navRef} className={Styles.desktop_nav}>
              <Navigation
                documentId={company.id ?? ''} progress={progress}
                changeData={changeData} navigation={navigation} setNavigation={setNavigation} setBackCaution={setBackCaution} />
            </div>

            {/* モバイル用ナビゲーションバー */}
            <div className={Styles.mobile_nav_bar} onClick={() => setMobileNavOpen(true)}>
              <span className={Styles.mobile_nav_bar_label}>{currentNavLabel}</span>
              <VscChevronRight className={Styles.mobile_nav_bar_icon} />
            </div>

            {/* モバイル用底部モーダル */}
            {mobileNavOpen && (
              <div className={Styles.mobile_modal_overlay} onClick={() => setMobileNavOpen(false)}>
                <div className={Styles.mobile_modal} onClick={e => e.stopPropagation()}>
                  <div className={Styles.mobile_modal_header}>
                    <span>セクションを選択</span>
                    <button onClick={() => setMobileNavOpen(false)}>✕</button>
                  </div>
                  {MOBILE_NAV_ITEMS.map(item => (
                    <div key={item.index} className={Styles.mobile_modal_item}
                      onClick={() => {
                        changeData && navigation !== item.index
                          ? setBackCaution(item.index)
                          : setNavigation(item.index);
                        setMobileNavOpen(false);
                      }}
                      style={{ fontWeight: navigation === item.index ? 'bold' : 'normal' }}>
                      <span>{item.label}</span>
                      {progress[item.index - 1]
                        ? <PiCheckCircleFill className={Styles.mobile_modal_check} />
                        : <VscChevronRight className={Styles.mobile_modal_arrow} />}
                    </div>
                  ))}
                  <button className={Styles.mobile_modal_save}
                    onClick={handleMobilePublish}
                    style={progress.slice(0, 8).every(Boolean) ? {} : { backgroundColor: '#fafafa', color: '#cccccc', border: '1px solid #EBEBEB', boxShadow: 'none', fontWeight: '400' }}>
                    公開
                  </button>
                </div>
              </div>
            )}

            <div className={Styles.center}>

              {navigation === 1 ?
              <Summary
                documentId={documentId}
                setChangeData={setChangeData}
                summary={memoizedSummary} setSummary={setSummary}
                onPreviewImage={registerSummaryPreviewImage} />
              : navigation === 2 ?
              <Stores
                documentId={documentId} setStoreImageLocal={setStoreImageLocal} />
              : navigation === 3 ?
              <Point
                documentId={documentId}
                setChangeData={setChangeData}
                point={memoizedPoint} setPoint={setPoint} />
              : navigation === 4 ?
              <Number
                documentId={documentId}
                setChangeData={setChangeData}
                number={memoizedNumber} setNumber={setNumber} />
              : navigation === 5 ?
              <Photos
                documentId={documentId}
                setChangeData={setChangeData}
                strong={memoizedStrong} setStrong={setStrong} />
              : navigation === 6 ?
              <Interview
                documentId={documentId}
                setChangeData={setChangeData}
                interviews={memoizedInterviews} setInterviews={setInterviews}
                interviewImage1File={interviewImage1File} setInterviewImage1File={setInterviewImage1File}
                interviewImage2File={interviewImage2File} setInterviewImage2File={setInterviewImage2File}
                interviewImage3File={interviewImage3File} setInterviewImage3File={setInterviewImage3File}
                interviewImage4File={interviewImage4File} setInterviewImage4File={setInterviewImage4File}
                interviewImage5File={interviewImage5File} setInterviewImage5File={setInterviewImage5File}
                interviewImage6File={interviewImage6File} setInterviewImage6File={setInterviewImage6File} />
              : navigation === 7 ?
              <Person
                documentId={documentId}
                setChangeData={setChangeData}
                person={memoizedPerson} setPerson={setPerson}
                // この編集画面はstatus===3(非公開/編集可能状態)のときしか表示されない
                // (status===1=公開中は上のPublicコンポーネントが出る)。
                // 編集に入るには必ず先に非公開化されるため、ここでのisPublishedは常にfalseになる。
                isPublished={false} />
              : navigation === 8 ?
              // <></>
              <Document
                documentId={documentId}
                setChangeData={setChangeData}
                document={memoizedDocument} setDocument={setDocument} />
              : <></> }
              <div style={{height: '30px'}}></div>

            </div>

            {/* デスクトップ用プレビュー（モバイルでは非表示） */}
            <div className={Styles.desktop_preview}>
              <div className={Styles.preview} style={ isWindows ? {zoom, height: "480px"} : {zoom}}>

                <RecruitPageHeader
                  companyId={company.id ?? ""}
                  summary={memoizedSummary} recruitStatus={true} preview
                  localImages={summaryLocalImages} />

                <RecruitPageTitle
                  title={"魅力3選"}
                  desc={"サロンが思う自社の魅力を3つにまとめて紹介"} />

                <RecruitPagePoint
                  point={memoizedPoint} pamphlet={memoizedPamphlet} preview />

                <div className={Styles.hr}></div>
                <RecruitPageTitle
                  title={"店舗紹介"}
                  desc={"企業が運営しているサロンを全て紹介"} />

                <RecruitPageStores companyId={company.id} searchType={""} searchPref={""} />

                <div className={Styles.hr}></div>
                <RecruitPageTitle
                  title={"数字で見る"}
                  desc={"魅力を伝わりやすく数字で表現"} />

                <RecruitPageNumber number={memoizedNumber} preview />

                <div className={Styles.hr}></div>
                <RecruitPageTitle
                  title={"写真で見る"}
                  desc={"魅力を写真で表現"} />

                <div className={Styles.image_appeal}>
                  <Slider imageName={memoizedStrong.item1.images} number={1} preview />
                  <h4 className={memoizedStrong.item1.title ? undefined : Styles.preview_ph}>
                    {memoizedStrong.item1.title || "例）こだわりの内装・撮影ブース"}
                  </h4>
                  <p className={memoizedStrong.item1.desc ? undefined : Styles.preview_ph}>
                    {memoizedStrong.item1.desc || "例）〇〇をコンセプトにした空間で、実際の撮影や施術の様子です。ここでどんな風に働けるかが伝わる説明を書きましょう。"}
                  </p>
                </div>

                <div className={Styles.image_appeal}>
                  <Slider imageName={memoizedStrong.item2.images} number={2} preview />
                  <h4 className={memoizedStrong.item2.title ? undefined : Styles.preview_ph}>
                    {memoizedStrong.item2.title || "例）スタッフの1日・休憩スペース"}
                  </h4>
                  <p className={memoizedStrong.item2.desc ? undefined : Styles.preview_ph}>
                    {memoizedStrong.item2.desc || "例）働くスタッフの雰囲気や、休憩時間の過ごし方など、入社後のイメージがわく一言を添えましょう。"}
                  </p>
                </div>

                <div className={Styles.image_appeal}>
                  <Slider imageName={memoizedStrong.item3.images} number={3} preview />
                  <h4 className={memoizedStrong.item3.title ? undefined : Styles.preview_ph}>
                    {memoizedStrong.item3.title || "例）研修・コンテストの様子"}
                  </h4>
                  <p className={memoizedStrong.item3.desc ? undefined : Styles.preview_ph}>
                    {memoizedStrong.item3.desc || "例）教育制度やイベントなど、成長できる環境が伝わる写真と説明にしましょう。"}
                  </p>
                </div>

                <div className={Styles.hr}></div>
                <RecruitPageTitle
                  title={"インタビュー"}
                  desc={"今、現役で働いている方の声を掲載"} />

                <div className={Styles.hr}></div>
                <RecruitPagesInterviews
                  interviews={memoizedInterviews} preview />

                <div className={Styles.hr}></div>
                <RecruitPageTitle
                  title={"求める人物像"}
                  desc={"求めている人物像を数値化"} />

                <RecruitPagesPerson
                  person={memoizedPerson} />

                {/* 「スタイル」「クーポン」「スタッフ紹介」「説明会」は /service/salonPr で管理する項目のため、
                    この求人編集プレビューには表示しない（どこで編集するか分からず混乱するため） */}

                <div style={{height: "100px"}}></div>

              </div>
            </div>
          </div>
        </div>
      </div>
    : status === 1 ?
      <Public documentId={documentId} />
    : <></> }

    {backCaution !== 0 ?
      <BackCaution backCaution={backCaution} setBackCaution={setBackCaution} setNavigation={setNavigation} setChangeData={setChangeData} />
    : <></> }
    </>
  );
}

export default Recruit;
